import { environment } from "./../../environment/environment.js";
import sha1 from "sha1";
import { sha256 } from "js-sha256";
import moment from "moment";

export var session = {
    methods: {
        encodeObject(object) {
            let result = "{}";
            try {
                const encoded = new TextEncoder().encode(object);
                const stringEncoded = JSON.stringify([].slice.call(encoded));
                result = window.btoa(stringEncoded);
            } catch (error) {
                console.log(error);
            }
            return result;
        },

        readEncodedObject(text) {
            let result = {};
            try {
                if (this.notBlank(text)) {
                    const stringDecoded = window.atob(text);
                    const arrayDecoded = JSON.parse(stringDecoded);
                    const bytesDecoded = new Uint8Array(arrayDecoded);
                    result = JSON.parse(new TextDecoder().decode(bytesDecoded));
                }
            } catch (error) {
                console.log(error);
            }
            return result;
        },

        // USER SESSION

        loadSession(applicationName) {
            const sessionName = this.getSessionName(applicationName);
            const sessionData = localStorage.getItem(sessionName);
            let sessionObject = this.readEncodedObject(sessionData);
            if (sessionObject && !this.emptyObject(sessionObject)) {
                sessionObject.loggedIn = this.notBlank(
                    sessionObject.details.token
                );
            } else {
                sessionObject = {
                    details: {},
                    loggedIn: false,
                };
            }
            return sessionObject;
        },

        saveSession(session, applicationName) {
            this.clearSession(applicationName);
            const sessionData = JSON.stringify(session);
            const sessionName = this.getSessionName(applicationName);
            const encodedData = this.encodeObject(sessionData);
            localStorage.setItem(sessionName, encodedData);
        },

        clearSession(applicationName) {
            const sessionName = this.getSessionName(applicationName);
            localStorage.removeItem(sessionName);
            const sessionNameGeneral = this.getSessionName(null);
            localStorage.removeItem(sessionNameGeneral);
            this.clearSessionInteraction(applicationName);
        },

        validateSession(applicationName) {
            const session = this.loadSession(applicationName);
            if (!session.loggedIn) {
                this.goToErrorForbidden();
            }
        },

        getSessionName(applicationName) {
            const env = environment.endpoint.name;
            const ses = applicationName
                ? "session-" + applicationName
                : "session";
            return sha1(env + "-" + ses);
        },

        // USER SESSOIN INTERACTIONS

        getSessionInteractionName(applicationName, suffix) {
            const env = environment.endpoint.name;
            const ses = applicationName
                ? "session-" + applicationName
                : "session";
            return sha1(env + "-" + ses + "-" + suffix);
        },

        clearSessionInteraction(applicationName) {
            const sessionInteractionName = this.getSessionInteractionName(
                applicationName,
                "interaction"
            );
            localStorage.removeItem(sessionInteractionName);
        },

        saveSessionInteraction(data, applicationName) {
            this.clearSessionInteraction(applicationName);
            const interactionData = JSON.stringify(data);
            const interactionName = this.getSessionInteractionName(
                applicationName,
                "interaction"
            );
            const encodedData = this.encodeObject(interactionData);
            localStorage.setItem(interactionName, encodedData);
        },

        loadSessionInteraction(applicationName) {
            const interactionName = this.getSessionInteractionName(
                applicationName,
                "interaction"
            );
            const interactionData = localStorage.getItem(interactionName);
            let interactionObject = this.readEncodedObject(interactionData);
            return interactionObject;
        },

        // FRAMEWORK SESSION

        clearFrameworkSession() {
            const frameworkSessionName = this.getFrameworkSessionName();
            localStorage.removeItem(frameworkSessionName);
        },

        getFrameworkSessionName() {
            const env = environment.endpoint.name;
            const ses = "framework-session";
            return sha1(env + "-" + ses);
        },

        loadFrameworkSession() {
            const frameworkName = this.getFrameworkSessionName();
            const frameworkData = localStorage.getItem(frameworkName);
            let frameworkObject = this.readEncodedObject(frameworkData);
            return frameworkObject;
        },

        saveFrameworkSession(data) {
            this.clearFrameworkSession();
            const frameworkData = JSON.stringify(data);
            const frameworkName = this.getFrameworkSessionName();
            const encodedData = this.encodeObject(frameworkData);
            localStorage.setItem(frameworkName, encodedData);
        },

        validateFrameworkSession() {
            return new Promise((resolve, reject) => {
                const fwk = this.loadFrameworkSession();
                if (!fwk.authenticated) {
                    this.clearFrameworkSession();
                    this.clearSession();
                    this.authenticateFramework()
                        .then((login) => {
                            if (login.success && login.status == 200) {
                                this.saveFrameworkSession({
                                    authenticated: true,
                                    token: login.data,
                                });
                                resolve(this.loadFrameworkSession());
                            } else {
                                reject();
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            reject();
                        });
                } else {
                    resolve(fwk);
                }
            });
        },

        authenticateFramework() {
            const date = moment()
                .utc()
                .format("YYYY-MM-DD");
            console.log(date);
            return new Promise((resolve, reject) => {
                const userName = sha256(
                    environment.global.name + "_" + environment.endpoint.name
                );
                const body = {
                    userName,
                    password: sha256(date + userName),
                };

                this.apiFrameworkAuthentication({ body })
                    .then((faRes) => {
                        const status = faRes.status;
                        const data = faRes.data;
                        switch (status) {
                            case 200: {
                                resolve(data);
                                break;
                            }
                            default: {
                                reject();
                                break;
                            }
                        }
                    })
                    .catch((faError) => {
                        console.log(faError);
                        reject();
                    });
            });
        },

        appContextLoadSession({ applicationName, generalExApplicationEx }) {
            let session = {};
            if (
                this.notBlank(applicationName) &&
                generalExApplicationEx.appLogin
            ) {
                session = this.loadSession(applicationName);
            } else {
                session = this.loadSession();
            }
            return session;
        },

        validateApplicationSession(applicationName, generalExApplicationEx, route) {
            const appAuthentication = applicationName && generalExApplicationEx?.applicationEx?.authentication;
            const session = appAuthentication ? this.loadSession(applicationName) : this.loadSession();
            const loggedIn = session?.loggedIn;
            if (route) {
                if (loggedIn) {
                    this.goToMain(applicationName);
                } else if (appAuthentication) {
                    this.goToLogin(applicationName);
                } else {
                    this.goToLogin();
                }
            }
            return session;
        },

        closeApplicationSession(applicationName, generalExApplicationEx) {
            const appAuthentication = applicationName && generalExApplicationEx?.applicationEx?.authentication;
            if (appAuthentication) this.goToLogin(applicationName);
            else this.goToLogin();

        }
    },
};
